module.exports = __webpack_public_path__ + "img/three2Green.e57341ec.jpg";